export const SALES_REP_OVERVIEW_TABLE_NAME = "SALES_REP_TABLE"